import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
 
import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import {variables} from './Variables.js';
import { FALSE } from 'sass';


 
 
export default function WhatNew_Home_Ar() {

 

    const [isLoading,setNisLoading] = useState(false);
    const navigate = useNavigate();
    const usenavigate=useNavigate();
   
    const JsonUrlWhatsnew = variables.basename_url +'updates/index/Athlethixnet_HomeAr_basketball.json';
  
      async function refda() {  
        //
document.getElementById('Main_Dir').dir = "rtl";

 
//
        Get_Data_WhatNew_Home_Ar();
  
      }


   
      useEffect(() => {
       
       
        setNisLoading(true);
   
        refda();
           },[] )




           const [JsonWhatsNewArray, setJsonJsonWhatsNewArray] = React.useState([]);

           async function Get_Data_WhatNew_Home_Ar(){
          
             JsonWhatsNewArray.splice(0);  //to clear All data in your page
         
            setNisLoading(true);
         
            axios.get(JsonUrlWhatsnew)  
         
                  .then(function (response) {
                  setNisLoading( false);
         
                    console.log(response.data);
                
                   
              
         
                  for (let i = 0; i < 5 && i < response.data.length; i++) {
                  
                   JsonWhatsNewArray.push({
                     news_title: response.data[i].news_title,
                     news_date:response.data[i].news_date.split(" ")[0],
                     news_imagename:response.data[i].Image   ,
                     link:response.data[i].link,
                    Category:response.data[i].Category
                   })
                   }
             })      
            };
         
         
         
 

 


            return (
          <>
 

          
 <div className="most-view-box float-right mb-3">
        <div className="section-title">
        
          <h3 className="title float-right">      ماذا جديد</h3>
         
        </div>
        <div className="trending-sidebar-slider slick-initialized   ">
          
          <div className="slick-list draggable float-right"><div className="slick-track" style={{opacity: 1}}>
            <div className="post_gallery_items slick-slide slick-cloned" data-slick-index={-1} aria-hidden="true" tabIndex={-1} style={{width: '300px'}}>
            </div>
 
            <div className="post_gallery_items slick-slide slick-cloned" data-slick-index={3} aria-hidden="true" tabIndex={-1}  >
              {JsonWhatsNewArray.map(da=>     
  
  <div key= {da.news_title}  >   
                <div className="post-gallery-style-2 most-view-style-2 ">
                  <div className="post-gallery-thumb  ">
                 <a  href={da.link }>
                 
 <img className='rounded  ' style={{ maxWidth: '85px', maxHeight: '57px' , minWidth: '85px', minHeight: '57px' }} src={da.news_imagename} alt="gallery" />
                  
                    </a>
                  </div>
                  <div className="post-gallery-content pr-3">
                    <h5 className="title  text-start"  ><a  href={da.link } >{da.news_title}</a></h5>

                    <div class="meta-post-2-style   mr-2">
                  
                                                <div class="meta-post-categores">
                                                    <a href={da.link} tabindex="-1">{da.Category}</a>
                                                </div>
                                                <div class="meta-post-date">
                                                {/* <span className=''>{new Date(da.news_date).toLocaleDateString('ar-GB')}</span> */}
                                                <span>{new Date(da.news_date).toLocaleDateString('ar-EG')}</span>
                                                </div>
                                               
                                            </div>
                  </div>
                  
                </div>
                <div className="">
               
                      </div>
              </div>
               )}
                </div>
                









              </div>
              </div>
           </div>
      </div>    

 
         </>
        );
    }


  
